import { CLEAR_CHECKOUT } from 'dux/checkout/actionTypes';
import {
  SET_CARD_PUBKEY,
  SET_PAYMENT_IS_READY,
  SET_STRIPE_TOKEN,
} from 'dux/checkoutPayment/actionTypes';

const initialStateStripe = { token: null, cardPubkey: null };

export const payment = (state = { isPaymentReady: false }, action) => {
  switch (action.type) {
    case SET_PAYMENT_IS_READY:
      return { ...state, isPaymentReady: action.isPaymentReady };
    default:
      return state;
  }
};

export const stripe = (state = initialStateStripe, action) => {
  switch (action.type) {
    case CLEAR_CHECKOUT:
      return initialStateStripe;
    case SET_STRIPE_TOKEN:
      return { token: action.token };
    case SET_CARD_PUBKEY:
      return { cardPubkey: action.cardPubkey };
    default:
      return state;
  }
};
